/**
 * Lets any page open the floating chat without owning it.
 *
 * The widget lives in the company layout and keeps its conversation there, so a
 * page cannot hold a reference to it. A window event keeps the two decoupled:
 * the page announces the intent, the widget (if it is mounted) acts on it.
 */
const ASK_ME_ANYTHING_OPEN_EVENT = 'ask-me-anything:open'

interface OpenAskMeAnythingDetail {
  question?: string
}

const openAskMeAnything = (detail: OpenAskMeAnythingDetail = {}) => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<OpenAskMeAnythingDetail>(ASK_ME_ANYTHING_OPEN_EVENT, { detail }))
}

export { ASK_ME_ANYTHING_OPEN_EVENT, openAskMeAnything }
export type { OpenAskMeAnythingDetail }
